module.exports = __webpack_public_path__ + "static/media/icon.c2ab2572.png";